import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type TreeSelect from './tree-select.vue'

export const treeSelectProps = buildProps({
  //  是否灰色样式
  isGray: {
    type: Boolean,
    default: false,
  },

  treeLine: {
    type: Boolean,
    default: false,
  },

  // 显示叶子图标
  showLeafIcon: {
    type: Boolean,
    default: false,
  },

  // 弹窗类名
  popupClassName: {
    type: String,
    default: '',
  },
} as const)

// props
export type TreeSelectProps = ExtractPropTypes<typeof treeSelectProps>

// instance
export type TreeSelectInstance = InstanceType<typeof TreeSelect>
